<mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Load Shipment">
        <form (ngSubmit)="gotoShipment()" autocomplete="off">
            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Shipment Number</mat-label>
                <input matInput #shipmentNbrField [formControl]="loadSOShipment" name="shipmentNbr" autofocus scanInput
                scanallowkeyboard inputmode="search" (scanned)="gotoShipment()" required />
                <button type="button" mat-icon-button matSuffix *ngIf="shipmentNbrField.value"
                    (click)="shipmentNbrField.value = ''">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-form-field>
        </form>
    </mat-tab>

    <!-- <mat-tab label="Create from SO">
        <form [formGroup]="createSOShipment" (ngSubmit)="createShipment()">
            <mayer-so-type-selector formControlName="soOrderType"></mayer-so-type-selector>

            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Sales Order Number</mat-label>
                <input matInput formControlName="soOrderNbr" name="soOrderNbr" required />
            </mat-form-field>

            <mat-error *ngIf="createShipmentError">
                <mat-icon>error</mat-icon> {{createShipmentError.message}}
            </mat-error>
        </form>
    </mat-tab> -->

    <mat-tab label="Print Confirm.">
        <form (ngSubmit)="printShipmentConfirmation()" autocomplete="off">
            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Shipment Number</mat-label>
                <input #printShipmentConfirmationNbrField matInput [formControl]="printShipmentConfirmationNbr"
                    required (keydown.enter)="printShipmentConfirmation()" />
            </mat-form-field>
        </form>
    </mat-tab>
</mat-tab-group>

<!-- <mat-tab-group #shipmentsListTabGroup (selectedTabChange)="selectedShipmentListTabChanged($event)"
    [selectedIndex]="shipmentListTabIndex">
    <mat-tab label="Yardage">

    </mat-tab>

    <mat-tab label="Samples">

    </mat-tab>
</mat-tab-group>

<table mat-table [dataSource]="shipmentListTabIndex==0 ? YardageShipments : SamplesShipments" class="ShipmentList">
    <ng-container matColumnDef="ShipmentNbr">
        <th mat-header-cell *matHeaderCellDef>Shipment #</th>
        <td mat-cell *matCellDef="let shipment"><button mat-stroked-button
                (click)="resumeShipment(shipment.ShipmentNbr)">{{shipment.ShipmentNbr}}</button></td>
    </ng-container>

    <ng-container matColumnDef="ShipmentDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let shipment">{{shipment.ShipmentDate | date:'M/d'}}</td>
    </ng-container>

    <ng-container matColumnDef="PickerID">
        <th mat-header-cell *matHeaderCellDef>Picker</th>
        <td mat-cell *matCellDef="let shipment">{{shipment.PickerID}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="ShipmentTableCols"></tr>
    <tr mat-row *matRowDef="let row; columns: ShipmentTableCols;"></tr>
</table> -->